export default "__VITE_ASSET__bd6abf51__"